import "./NotFound.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = ({ dark }) => {
  return (
    <div className={`notfound`}>
      <Helmet>
        <title>Page Not Found (404) | FadaSports</title>
        <meta name="description" content="The page you are looking for does not exist or has been moved. Return to FadaSports homepage or search for what you need." />
        <meta name="keywords" content="404, not found, page not found, error" />
        <meta name="author" content="FadaSports" />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Page Not Found" />
        <meta property="og:description" content="This page does not exist. Please return to FadaSports." />
        <meta property="og:image" content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="FadaSports" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FadaSports" />
      </Helmet>
      <div className="notfound-content">
        <h1>404</h1>

        <h2 style={dark ? {} : {color: "#3e3f3f"}}>Page not found</h2>

        <p style={dark ? {color: "#fafafaff"} : {color: "#3e3f3fee"}}>
          The page you’re looking for doesn’t exist or has been moved.
        </p>

        <div className="actions">
          <Link to="/" className="home-btn">
            Go Home
          </Link>

          <Link to="/search" className="search-btn" >
            Search Instead
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;